import { createContext, useContext } from "react";
import { useImmerReducer } from "use-immer";

const universalLoaderInit = {
  isUniversalLoading: false,
};

function universalLoaderReducer(draft, { type, payload }) {
  switch (type) {
    case "setIsUniversalLoading": {
      draft.isUniversalLoading = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [UniversalLoaderContext, UniversalLoaderDispatchContext] = [
  createContext(null),
  createContext(null),
];

export default function UniversalLoaderProvider({ children }) {
    const [universalLoaderStore, dispatch] = useImmerReducer(universalLoaderReducer, universalLoaderInit);

  return (
    <UniversalLoaderContext.Provider value={universalLoaderStore}>
      <UniversalLoaderDispatchContext.Provider value={dispatch}>
        {children}
      </UniversalLoaderDispatchContext.Provider>
    </UniversalLoaderContext.Provider>
  );
}

export function useUniversalLoaderStore() {
  return useContext(UniversalLoaderContext);
}

export function useUniversalLoaderDispatch() {
  return useContext(UniversalLoaderDispatchContext);
}